<template>
    <div>
        <div class="cart__promo" v-if="!isPcDiscount">
            <input v-model="pc_code" class="cart__promo-input" id="promo" name="promo" type="text" placeholder="Ваш промокод"/>
            <button type="button" v-on:click="applyPromocode()" class="btn btn--blue cart__promo-btn">Применить</button>
        </div>
        <div class="cart__promo" v-else>
            <input :value="getPromo" disabled="true" class="cart__promo-input" type="text"/>
            <button type="button" v-on:click="disablePromocode()" class="btn btn--blue cart__promo-btn">Отменить</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cart-promo",
        computed: {
            isPcDiscount () {
                return this.$store.getters.pc_discount
            },
            getPromo () {
                let ret = this.$store.getters.pc_code;
                return ret.slice(0, 2).padEnd(ret.length, '*')
            }
        },
        data () {
            return {
                pc_code: ''
            }
        },
        methods: {
            applyPromocode () {
                this.$store.dispatch('applyPromocode', this.pc_code)
                this.pc_code = this.$store.getters.pc_code
            },
            disablePromocode () {
                this.$store.dispatch('disablePromocode')
            }
        }
    }
</script>

<style scoped>

</style>